module.exports = __webpack_public_path__ + "img/PXL_20230523_145116651.ff8b90c7.jpg";